export const orgAgreementTranslations = {
  lv: {
    title: 'Līgumi',
    description: 'Katram praktikantam savs līgums. Bezmaksas kontā parakstāt pats.',
    count_zero: '{{count}} līgumu',
    count_one: '{{count}} līgums',
    count_other: '{{count}} līgumi',
    search: 'Meklēt līgumu…',
    empty: 'Līgumi nav atrasti',
    columns: {
      intern: 'Praktikants',
      nr: 'Nr.',
      eduOrgName: 'Izglītības iestāde',
      internship: 'Prakse',
      supervisorStart: 'Sākums',
      supervisorEnd: 'Beigas',
      Edu: 'Iestādes paraksts',
      Intern: 'Praktikanta paraksts',
      Org: 'Mūsu paraksts',
      status: 'Statuss',
    },
    statuses: {
      toSignEdu: 'Gaida iestādes parakstu',
      toSignIntern: 'Gaida praktikanta parakstu',
      toSignOrg: 'Gaida mūsu parakstu',
      signed: 'Parakstīts',
    },
    signedBy: 'Parakstīts — {{signatory}}, {{date}}',
    notSigned: 'Nav parakstīts',
    notYet: 'Šī darbība vēl nav pieejama: {{action}}',
    actions: {
      menu: 'Līguma darbības',
      sign: 'Parakstīt',
      download: 'Lejupielādēt līgumu',
    },
    messages: {
      downloadError: 'Neizdevās lejupielādēt līgumu.',
    },
  },
  en: {
    title: 'Agreements',
    description: 'Each intern has their own agreement. In a free account, you sign it yourself.',
    count_one: '{{count}} agreement',
    count_other: '{{count}} agreements',
    search: 'Search agreements…',
    empty: 'No agreements found',
    columns: {
      intern: 'Intern',
      nr: 'No.',
      eduOrgName: 'Educational institution',
      internship: 'Internship',
      supervisorStart: 'Start',
      supervisorEnd: 'End',
      Edu: 'Institution signature',
      Intern: 'Intern signature',
      Org: 'Our signature',
      status: 'Status',
    },
    statuses: {
      toSignEdu: 'Awaiting the institution’s signature',
      toSignIntern: 'Awaiting the intern’s signature',
      toSignOrg: 'Awaiting our signature',
      signed: 'Signed',
    },
    signedBy: 'Signed — {{signatory}}, {{date}}',
    notSigned: 'Not signed',
    notYet: 'This action is not available yet: {{action}}',
    actions: {
      menu: 'Agreement actions',
      sign: 'Sign',
      download: 'Download agreement',
    },
    messages: {
      downloadError: 'Could not download the agreement.',
    },
  },
}
